// extracted by mini-css-extract-plugin
module.exports = {"spinnerWrapper":"rkl-loading-spinner_spinnerWrapper__3PTjx","spinner":"rkl-loading-spinner_spinner__14jcT","spin":"rkl-loading-spinner_spin__2CUDw"};